import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-19 ant-col-xl-19" }, null, -1)
const _hoisted_3 = { class: "ant-col ant-col-xs-5 ant-col-xl-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cenario_fiscal_definicao_icms = _resolveComponent("cenario-fiscal-definicao-icms")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_cenario_fiscal_duplicar_definicao_icms_modal = _resolveComponent("cenario-fiscal-duplicar-definicao-icms-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_tabs, {
      activeKey: _ctx.state.indexSelecionado,
      "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.indexSelecionado) = $event))
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.computedDefinicoes, (definicao, index) => {
          return (_openBlock(), _createBlock(_component_a_tab_pane, {
            key: index,
            tab: definicao.siglaEstado
          }, {
            default: _withCtx(() => [
              _createVNode(_component_cenario_fiscal_definicao_icms, {
                definicao: _ctx.computedDefinicoes[index],
                "onUpdate:definicao": ($event: any) => ((_ctx.computedDefinicoes[index]) = $event),
                "tipos-atividade": _ctx.computedTiposAtividade[index],
                "onUpdate:tiposAtividade": ($event: any) => ((_ctx.computedTiposAtividade[index]) = $event)
              }, null, 8, ["definicao", "onUpdate:definicao", "tipos-atividade", "onUpdate:tiposAtividade"])
            ]),
            _: 2
          }, 1032, ["tab"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["activeKey"]),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "ant-btn ant-btn-secondary ss-botao-secundario",
          style: {"width":"92%","height":"90%","margin-top":"5px","white-space":"normal","line-height":"1.2","text-align":"center"},
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.abrirDuplicacao && _ctx.abrirDuplicacao(...args)))
        }, "Copiar definição para outros estados")
      ])
    ]),
    _createVNode(_component_cenario_fiscal_duplicar_definicao_icms_modal, {
      estados: _ctx.props.estados,
      "estado-origem": _ctx.state.estadoSelecionado,
      visivel: _ctx.state.exibirDuplicacao,
      "onUpdate:visivel": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.exibirDuplicacao) = $event)),
      onConfirmar: _ctx.duplicarEstados
    }, null, 8, ["estados", "estado-origem", "visivel", "onConfirmar"])
  ], 64))
}